import type { ReactNode } from 'react';
import { ApiError } from '../api/client';

export function PageHead({ title, eyebrow, children, actions }: { title: string; eyebrow?: string; children?: ReactNode; actions?: ReactNode }) {
  return (
    <div className="page-head">
      <div>
        {eyebrow && <div className="eyebrow">{eyebrow}</div>}
        <h1>{title}</h1>
        {children && <p className="muted">{children}</p>}
      </div>
      {actions && <div className="actions">{actions}</div>}
    </div>
  );
}

export function RoleBadge({ role }: { role: string }) {
  const labels: Record<string, string> = {
    agent: 'Agent',
    chef_service: 'Chef de service',
    drh: 'DRH',
    elu: 'Élu',
    admin: 'Administrateur',
    integration: 'Intégration',
  };
  return <span className="b b-acc">{labels[role] ?? role}</span>;
}

export function StatusBadge({ status }: { status: string }) {
  if (status === 'signed') return <span className="b b-ok">Signé</span>;
  if (status === 'draft') return <span className="b b-warn">Brouillon</span>;
  return <span className="b b-min">{status}</span>;
}

export function ErrorNote({ error }: { error: unknown }) {
  if (!error) return null;
  const message = error instanceof ApiError ? error.message : error instanceof Error ? error.message : String(error);
  const details = error instanceof ApiError ? error.details : undefined;
  return (
    <div className="note bad" role="alert">
      <strong>{message}</strong>
      {details && details.length > 0 && (
        <ul>
          {details.map((d) => (
            <li key={d.path}>
              <code>{d.path}</code> : {d.message}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export function Loading({ what = 'Chargement' }: { what?: string }) {
  return <div className="empty">{what}…</div>;
}

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return '—';
  const [y, m, d] = iso.slice(0, 10).split('-');
  return `${d}/${m}/${y}`;
}

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  return new Date(iso).toLocaleString('fr-FR', { dateStyle: 'short', timeStyle: 'medium' });
}
